// extracted by mini-css-extract-plugin
export default {"loginContent":"AuthBySms_loginContent__O+2S+","loginForm":"AuthBySms_loginForm__kZfuy"};